export const ExternalLinks = {
  CONTACT_SUPPORT: process.env.SUPPORT_REQUEST_URL,
  ONBOARDING: process.env.ONBOARDING_URL,
  PRIVACY_POLICY_URL: process.env.PRIVACY_POLICY_URL,
  LICENSES_HELP_URL: process.env.LICENSES_HELP_URL,
  EMBEDDED_WALLETS_LEARN_MORE: process.env.EMBEDDED_WALLETS_LEARN_MORE,
  ROLES_FAQ: process.env.ROLES_FAQ,
}

export const BASE_API_URL = process.env.API_URL
